import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

const FALLBACK_DSN = 'https://22e123eaf69c4fc1b4845c47412ccd6a@bugsink.service.cyberholding.ru/2'

/**
 * Bugsink error monitoring (@sentry/vue). Call before `app.mount`.
 * `VITE_SENTRY_DSN=` (empty) in a local env file silences reporting.
 * Errors only — traces and metrics stay off (Bugsink ingest contract).
 */
export function initSentry(app: App): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN === '' ? undefined : import.meta.env.VITE_SENTRY_DSN || FALLBACK_DSN
    if (!dsn) return
    if (!Sentry.getClient()) {
        Sentry.init({
            app,
            dsn,
            environment: 'prod',
            release: __APP_VERSION__,
            // v11 replacement for the removed `sendDefaultPii` flag (Bugsink
            // recommends maximal context on self-hosted): collect all request
            // data (user info, headers, cookies, bodies, query params).
            dataCollection: {
                userInfo: true,
                cookies: true,
                urlQueryParams: true,
                httpBodies: ['incomingRequest', 'outgoingRequest', 'incomingResponse', 'outgoingResponse'],
                stackFrameVariables: true,
            },
            tracesSampleRate: 0,
        })
        Sentry.getGlobalScope().setTag('component', 'spa')
    }
}
